import ApplicationStatus from 'features/signup/ApplicationStatus/ApplicationStatus';
import React from 'react';

export default function Page() {
  return <ApplicationStatus />;
}
